export default "__VITE_ASSET__CAHgfulT__"